
// Assuming 4 quarter segments in a circle
const segments = 4

// Theta is an approximation of a circle with cubic Bezier curves
const theta = (4 / 3) * Math.tan(Math.PI / (2 * segments))

export default function (path, center = [], radius, startAngle, clockwise = true) {
  const [centerX, centerY] = center
  const endAngle = startAngle + (clockwise ? 1 : -1) * Math.PI / 2

  const startX = centerX + radius * Math.cos(startAngle)
  const startY = centerY + radius * Math.sin(startAngle)
  const endX = centerX + radius * Math.cos(endAngle)
  const endY = centerY + radius * Math.sin(endAngle)

  let cp1X, cp1Y, cp2X, cp2Y
  if (clockwise) {
    cp1X = startX - theta * radius * Math.sin(startAngle)
    cp1Y = startY + theta * radius * Math.cos(startAngle)
    cp2X = endX + theta * radius * Math.sin(endAngle)
    cp2Y = endY - theta * radius * Math.cos(endAngle)
  } else {
    cp1X = startX + theta * radius * Math.sin(startAngle)
    cp1Y = startY - theta * radius * Math.cos(startAngle)
    cp2X = endX - theta * radius * Math.sin(endAngle)
    cp2Y = endY + theta * radius * Math.cos(endAngle)
  }
  path.bezierCurveTo(cp1X, cp1Y, cp2X, cp2Y, endX, endY)
}
